const selectors = {
  statusMessage: '[data-status-message]',
};

export function addStatusMessage(string) {
  const statusMessage = document.querySelector(selectors.statusMessage);

  if (!statusMessage) return;

  statusMessage.innerHTML = string;
}

export function clearStatusMessage() {
  const statusMessage = document.querySelector(selectors.statusMessage);

  if (!statusMessage) return;

  statusMessage.innerHTML = '';
}
